import { Helmet } from "react-helmet";
import hero from "../images/environmentalHero.jpg";
import canoe from "../images/mauiIcon (1).jpg";
import submarine from "../images/mauiIcon (2).jpg";
import triangle from "../images/waikikiIcon (1).jpg";

function Environmental() {
  return (
    <>
      <Helmet>
        <title>Atlantis Submarine Adventures | Environmental Highlights</title>
      </Helmet>
      <div className="container mw-100">
        <div className="row">
          <img
            src={hero}
            className="p-0 aboutHero"
            style={{ objectPosition: "left" }}
            alt="hero"
          />
        </div>
        <div
          className="row bg-white text-start justify-content-center"
          style={{ color: "#03286B" }}
        >
          <div className="col-12 col-md-10 col-xl-9 col-xxl-6 py-5">
            <p className="fw-bold mb-5 fs-2 text-center">
              ENVIRONMENTAL HIGHLIGHTS
            </p>
            <div className="row mw-100 justify-content-center mb-4 mb-md-0">
              <div className="col-3 p-0 d-flex align-items-center">
                <img
                  src={triangle}
                  className="py-0 px-sm-3 px-lg-4 w-100"
                  alt="triangle icon"
                />
              </div>
              <div className="col-9 align-items-center d-flex p-0">
                <p className="p-0 m-0 ps-3 ps-sm-5">
                  Atlantis Adventures has invested millions in environmentally
                  friendly artificial reefs such as carefully cleaned, sunken
                  ships, which provide habitats for marine life to help protect
                  and grow Hawaii's marine ecosystem.
                </p>
              </div>
            </div>
            <div className="row mw-100 justify-content-center mb-4 mb-md-0">
              <div className="col-3 p-0 d-flex align-items-center">
                <img
                  src={submarine}
                  className="py-0 px-sm-3 px-lg-4 w-100"
                  alt="submarine icon"
                />
              </div>
              <div className="col-9 align-items-center d-flex p-0">
                <p className="p-0 m-0 ps-3 ps-sm-5">
                  Atlantis operates battery-powered, state-of-the-art passenger
                  submarines. Our eco-friendly, quiet submarines emit no
                  pollutants in Hawaii's coastal waters and minimize disturbance
                  to marine life.
                </p>
              </div>
            </div>
            <div className="row mw-100 justify-content-center mb-0">
              <div className="col-3 p-0 d-flex align-items-center">
                <img
                  src={canoe}
                  className="py-0 px-sm-3 px-lg-4 w-100"
                  alt="canoe icon"
                />
              </div>
              <div className="col-9 align-items-center d-flex p-0">
                <p className="p-0 m-0 ps-3 ps-sm-5">
                  For 38 years, Atlantis Submarines has educated guests about
                  Hawaii's ocean, reefs, and marine life through engaging
                  submarine tour narrations. Join us for a fun exploration
                  beneath the sea!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Environmental;
